var _implements = require('util/interface')._implements;
var requireNonNull = require('util/require-non-null');
var ErrorReport = require('../../error-report');

module.exports = _implements(ErrorReport, function ErrorReportImpl(message, line, column) {
    this.message = requireNonNull(message);
    this.line = line || 0;
    this.column = column || 0;

    this.toString = function() {
        return "ErrorReport [" + this.message + " at [" + this.line + ":" + this.column + "]]";
    };
});



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/error-report.js
// module id = 306
// module chunks = 1